import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/Navbar/NavbarView.vue';
import { get_token } from "@/router";
import Swal from 'sweetalert2';

export default {
  components: {
    Sidebar,
    Navbar
  },
  data() {
    return ({
      groups: [],
      group_id: '',
      group_name: '',
      group_description:'',
      portal_id: "",
      is_public: true,
      editing: false,
      editing_group_id: null,
      isSubmitting: false,
      token_exists: false,
      errors: {},
      portals: [],
      selectedPortalId: null,
      selectedVisibility: 'public',
      isLoading: true,
    });
  },
  mounted() {
    this.token_exists = get_token(); 
    this.fetch_portal();
    this.fetchGroups().then(() => {
      this.$nextTick(() => {
        $('.table').DataTable({
          paging: true,
          searching: true,
          ordering: true,
          info: true,
          lengthChange: true,
          pageLength: 10,
          language: {
            paginate: {
              previous: "Previous",
              next: "Next"
            },
            info: "Showing _START_ to _END_ of _TOTAL_ entries",
            infoEmpty: "No entries available"
          },
          sortColumn: '',
          sortDirection: 'asc'
        });
        this.isLoadin= false
      });
    });
  },
  computed: {
    isPublic() {
      return this.selectedVisibility === 'public';
    },
  },
  methods: {
    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle("close");
    },
    validationGroupForm() {
      this.errors = {};
      let valid = true;

      if (!this.group_name) {
        this.errors.group_name = 'Group name is required';
        valid = false;
      }

      return valid;
    },
    handle_submit() {
      if (!this.editing) {
        this.create_group();
        this.editing = false;
        return;
      }
      this.update_group();
    },
    create_group() {
      if (!this.validationGroupForm()) {
        return;
      }
      this.isSubmitting = true;
      const payload = {
        name: this.group_name,
                is_public:this.is_public,
        portal_id:this.selectedPortalId,
      };
      if (this.group_description.trim()) {
        payload.description = this.group_description;
      }

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/create_group/`,
        contentType: "application/json",
        headers: {
                  'Authorization': `Token ${this.getToken()}`,
                  'Content-Type': 'application/json'
        },
        data: JSON.stringify(payload),
        success: (response) => {
          const status = response.status;
          if (status === "success") {
            Swal.fire({
              icon: "success",
              title: "Success",
              text: "Created Successfully",
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.fetchGroups();
              $("#create_group_modal").modal("hide");
            });
          }
        },
        error: (response) => {
          const response_data = response.responseJSON;
          if (response_data.status === "error") {
            this.errors.group_name = response_data.message;
          }
        },
        complete: () => {
          this.isSubmitting = false;
        },
      });
      },
      fetch_portal() {
      this.isLoading = true;
      $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_portals_api/`,
      method: 'POST',
      headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
      },
      data: JSON.stringify(this.payload),

      success: (data) => {

            const portals = data.portals;
            this.portals=portals.filter(portal=>portal.portal_type.name=="engagement");
            this.portals = this.portals.filter(
                  portal => portal.name?.toLowerCase() !== 'default portal'
                );
      },
      complete: () => {
          this.isLoading = false;
      }
      });
    },

    fetchGroups() {
      this.isLoading = true;
      return new Promise((resolve) => {
        $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/get_all_group/`,
          method: 'GET',
          headers: {
            'Authorization': `Token ${this.getToken()}`,
            'Content-Type': 'application/json'
          },
          success: (data) => {
            this.groups = data.groups;
            resolve();
          },
          complete: () => {
            this.isLoading = false;
          }
        });
      });
    },

    deleteGroup(groupId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "This action cannot be undone!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          try {
            const response = await fetch(`${process.env.VUE_APP_BACKEND_API_URL}/group_management/delete_group/`, {
              method: 'DELETE',
              headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ group_id: groupId })
            });
            if (response.ok) {
              Swal.fire({
                icon: 'success',
                title: 'Deleted!',
                text: 'deleted Successfully.',
                showConfirmButton: false,
                timer: 1000,
                position: 'bottom-end',
                toast: true
              }).then(() => {
                this.groups = this.groups.filter(group => group.id !== groupId);
              });
            } else {
              throw new Error();
            }
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'An error occurred while deleting. Please try again!',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
     open_edit_group_modal(group) {
      this.editing = true;
      this.group_name = group.name;
      this.group_description = group.description ||'';
      this.is_public = group.is_public;
      this.editing_group_id = group.id;
    },
    update_group() {
      if (!this.validationGroupForm()) {
            return;
          }
        const payload = {
          name: this.group_name,
          group_id: this.editing_group_id,
          description: this.group_description,
          is_public : this.is_public,

        };
        if (this.group_description.trim()) {
          payload.description = this.group_description;
        }
  
        $.ajax({
          type: "POST",
          url: `${process.env.VUE_APP_BACKEND_API_URL}/group_management/update_group/`,
          contentType: "application/json",
          headers: {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          },
          data: JSON.stringify(payload),
          success: (response) => {
            const status = response.status;
            if (status === "success") {
              Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Updated Successfully',
                showConfirmButton: false,
                timer: 2000,
                        position: 'bottom-end',
                        toast: true
              }).then(() => {
                this.fetchGroups();
                $("#create_group_modal").modal("hide");
                this.editing = false;
              });
            }
          },
          error: (response) => {
            const response_data = response.responseJSON;
                    if (response_data.status==="error") {
                      this.errors.group_name =response_data.message
            }
          },
          complete: () => {
            this.isSubmitting = false;
          },
        });
      },
  }
};

